/**
 * I accept a value or an array of values and return a new array containing all
 * the non-null values passed. Flattening is not performed.
 * @param valueOrArray the value or array (or null) to repackage as an array of
 *  values
 * @return {*[]} an array of passed values, possibly empty, never null.
 */
const asArray = valueOrArray =>
    valueOrArray == null
        ? []
        : valueOrArray instanceof Array
        ? valueOrArray.filter(it => it != null)
        : [valueOrArray];

export default asArray;



// WEBPACK FOOTER //
// ./app/data/util/asArray.js